export enum EncounterTypes {
  Prenatal = "Prenatal",
  Postpartum = "Postpartum",
  Gynecological = "Gynecological",
  NewbornIPP = "Newborn IPP",
  NewbornPostpartum = "Newborn Postpartum",
  LaborAndDelivery = "Labor and Delivery",
  EarlyCare = "Early Care",
  TransferOfCare = "Transfer of Care",
  PrimaryCare = "Primary Care",
  Other = "Other",
}
